import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=f70bdfe2&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports